import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/terms/page.tsx");
